import React from "react";
import { Link, useNavigate } from "react-router-dom";

const NavigationButtons = ({ dashboardLink = "/admin/dashboard" }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-row items-center gap-3 w-full">
      <Link to={dashboardLink}>
        <button className="text-blue-600 h-[40px] text-nowrap border border-blue-600 rounded-lg w-[150px]">
          Back To Dashboard
        </button>
      </Link>
      <button
        className="text-blue-600 border h-[40px] text-nowrap border-blue-600 rounded-lg w-[150px]"
        onClick={() => navigate(-1)}
      >
        Go Back
      </button>
    </div>
  );
};

export default NavigationButtons;
